export default "__VITE_ASSET__BGFGHtfe__"